import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...this.props}><title>GitHub icon</title><path d="M12 .3a12 12 0 0 0-3.8 23.38c.6.12.83-.26.83-.57l-.02-2c-3.3.7-4-1.6-4-1.6-.5-1.4-1.3-1.74-1.3-1.74-1.1-.72.1-.7.1-.7 1.2.1 1.84 1.23 1.84 1.23 1.07 1.83 2.8 1.3 3.5 1 .1-.78.4-1.3.75-1.6-2.67-.3-5.47-1.34-5.47-5.94 0-1.3.47-2.4 1.24-3.23a4.3 4.3 0 0 1 .1-3.2s1-.32 3.3 1.2c.96-.23 1.98-.4 3-.4s2.04.17 3 .4c2.28-1.52 3.3-1.2 3.3-1.2.63 1.65.23 2.87.1 3.17.77.83 1.24 1.9 1.24 3.2 0 4.6-2.8 5.6-5.47 5.9.4.36.8 1.1.8 2.2v3.3c0 .3.2.7.8.58A12 12 0 0 0 12 .3" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/svgs/github.svg